'use strict';

import angular from 'angular';
import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';
import ngMaterial from 'angular-material';
import ngMessages from 'angular-messages';
import 'angular-loading-bar';
import 'angular-socket-io';
import 'angular-translate';
import 'angular-translate-loader-static-files';
import 'angular-translate-storage-local';
import moment from 'moment';
import mdDataTable from 'md-data-table';
import mdDataTable2 from 'angular-material-data-table';
import uiRouter from 'angular-ui-router';
import mdPickers from 'mdPickers';
require('../../node_modules/angular-material-event-calendar/index');
require('../../node_modules/angular-material-calendar/angular-material-calendar');
module.exports = 'materialCalendar';
require('angular-i18n/angular-locale_pl-pl.js');
import {
  routeConfig
} from './app.config';
import { Enum } from './shared/enum/index';
import _Auth from '../components/auth/auth.module';
import account from './account';
import admin from './admin';
import navbar from '../components/navbar/navbar.component';
import mainHeader from '../components/main-header/main-header.component';
import footer from '../components/footer/footer.component';
import constants from './app.constants';
import util from '../components/util/util.module';
import filter from '../filter/index';
import socket from '../components/socket/socket.service';
import shared from '../components/shared/shared.module';
import leftnav from '../components/leftnav/leftnav.module';
import leftNavMenuItem from '../components/leftnav/menu-item/menu-item.component';
import pageTitle from '../components/page-title/page-title.component';
import mainModule from './main/main';
import sharedModel from './shared/model/index';
import sharedService from './shared/service/index';
import './app.scss';
import '../customLib/angular-loading-bar/loading-bar.css';

angular.module('ngOskCrmApp', [ngCookies, ngResource, ngSanitize, ngAnimate, 'btford.socket-io', uiRouter,
  _Auth, account, admin, navbar, mainHeader, footer, constants, socket, util, ngMaterial, ngMessages,
  shared, 'angular-loading-bar', leftnav, pageTitle, mainModule, 'pascalprecht.translate', sharedModel, sharedService,
  mdDataTable, filter, mdDataTable2, mdPickers, 'materialCalendar', 'material.components.eventCalendar'
])
  .config(routeConfig)
  .run(function($rootScope, $location, Auth, $state, $transitions) {
    'ngInject';
    // Redirect to login if route requires auth and you're not logged in

    $state.transitionTo('main.clients');

    $rootScope.$on('$stateChangeStart', function(event, next) {
      Auth.isLoggedIn(function(loggedIn) {
        if(next.authenticate && !loggedIn) {
          $location.path('/login');
        }
      });
    });
  });

angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['ngOskCrmApp'], {
      strictDi: true
    });
  });



// WEBPACK FOOTER //
// ./client/app/app.js